import React from 'react';
import { useDispatch } from 'react-redux';
import AboutEvent from '../components/UiComponent/AboutEvent';
import Feedback from '../components/UiComponent/Feedback';
import ExploreEvents from '../components/ExploreAll/ExploreEvents';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import BackToTop from '../components/Buttons/BackToTop';
import { getUserLocation } from '../app/store/slices/userGeolocation';

export default function Homepage() {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(getUserLocation());
    }, [dispatch]);

    return (
        <React.Fragment>
            <ExploreEvents />
            <AboutEvent />
            <HowItWorks />
            <Feedback />
            <BackToTop />
        </React.Fragment>
    );
}
